import { ADMIN_PANEL_CLIENT_ID } from 'constants/auth';
import { withDirectModifiedFields } from 'utils/pendingChanges';

export class LoanApplicationsApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getLoanApplication({ companyId, applicationId }) {
    return this.#http.get(
      `/api/companies/${companyId}/loanapplications/${applicationId}?forClient=${ADMIN_PANEL_CLIENT_ID}`,
    );
  }

  async getLoanSummary({ applicationId }) {
    return withDirectModifiedFields(
      await this.#http.get(`/api/applications/${applicationId}/loaninfo/summary`),
    );
  }

  async getLoanInfo({ applicationId }) {
    return this.#http.get(`/api/applications/${applicationId}/loan-info`);
  }

  async getLoanProgram({ applicationId }) {
    return this.#http.get(`/api/applications/${applicationId}/loan-program`);
  }

  async createOriginatedLoan(companyId, body) {
    return this.#http.post(`/api/companies/${companyId}/loanapplications`, body);
  }

  async recordDisclosureAttestations({ applicationId, formBundleId, attestations, leGeneration }) {
    return this.#http.post(`/api/loanapplications/${applicationId}/disclosure-attestations`, {
      formBundleId,
      attestations,
      leGeneration,
    });
  }
}
